import React, { Fragment } from "react";
import {
  Row,
  Button,
  Label,
  Input,
  Form,
  FormGroup,
  Col,
  Card,
  CardBody,
  CardTitle
} from "reactstrap";

function Login() {
  return (
      <Fragment>
        <Col lg="12" xl="10" md="12" className="mx-auto my-5">
          <Card>
            <Row className="no-gutters">
              <Col xl="4" lg="12" className="loginBoxBg">
                <Card className="boxshadow-0 transparent-card">
                  <CardBody>
                    <a
                      href="#"
                      className="navbar-brand navbar-logo ml-3 navbar-brand"
                    >
                      <img
                        className="logo-login-page"
                        src="/assets/img/logo-light.png"
                      />
                    </a>

                    <p className="text-white mt-5">
                      React is a JavaScript library for building user
                      interfaces. It is maintained by Facebook and a community
                      of individual developers and companies. React can be used
                      as a base in the development of single-page or mobile
                      applications.{" "}
                    </p>
                    <ul>
                      <li className="text-white">Powerful UI</li>
                      <li className="text-white">Fully responsive</li>
                      <li className="text-white">Widely being used</li>
                      <li className="text-white">Made with love</li>
                      <li className="text-white">Recommended by pros</li>
                    </ul>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="4" lg="6" md="6" className="no-gutters">
                <Card className="boxshadow-0 margin-right-2px">
                  <CardBody>
                    <CardTitle>
                      Welcome back again!
                      <div className="mt-5">
                        <CardTitle>
                          <p>
                            <strong>Login</strong>
                          </p>
                        </CardTitle>
                        <Form>
                          <FormGroup>
                            <Label for="yourEmail">Email :</Label>
                            <Input
                              type="email"
                              name="email"
                              id="yourEmail"
                              placeholder="Your email.."
                            />
                          </FormGroup>

                          <FormGroup>
                            <Label for="yourPassword">Password :</Label>
                            <Input
                              type="password"
                              name="yourPassword"
                              id="yourPassword"
                              placeholder="Your password..."
                            />
                          </FormGroup>

                          <Button
                            href="#"
                            className="btn-shadow mt-4"
                            color="primary"
                            size="lg"
                          >
                            Login
                          </Button>
                        </Form>
                      </div>
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="4" lg="6" md="6" className="no-gutters">
                <Card className="boxshadow-0">
                  <CardBody>
                    <CardTitle>
                      <strong>Also, you can...</strong>

                      <div className="mt-5">
                        <Button
                          href="/register"
                          color="primary"
                          className="btn-shadow"
                          size="lg"
                        >
                          Register Now
                        </Button>
                      </div>
                    </CardTitle>{" "}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Card>
        </Col>
      </Fragment>
    );
}

export default Login;
